import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export namespace MSStandardEvent {
  export class Error {}
  export class Loading {}

  export type Spec = Error | Loading;
}

/* This function is used to filter out the #MSStandard.Loading events that are the same. */
export function distinctLoading<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged<T>(
    (previous, current) => previous instanceof MSStandardEvent.Loading && current instanceof MSStandardEvent.Loading
  );
}
